import React from 'react';

const HeaderLayout = () => {


    return (
        <header className="">
            <div className="container">
                <div className="nav-brand">
                    <a href="https://games.novandi.cl/">
                        <h1 className='color-titulo'>
                            <i className="snes-jp-logo brand-logo"></i>Novandi Games
                        </h1>
                    </a>{" "}
                    <p>Somos algo más que juegos.</p>
                </div>{" "}
            </div>
        </header>
        
    )
}

export default HeaderLayout;